
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publishing/collaboration/notifications",
      function () {
        return require("private-next-pages/publishing/collaboration/notifications.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/publishing/collaboration/notifications"])
      });
    }
  